import dupeBusinessClient from "./DupeBusinessClient";

export async function saveAccessToken(req) {
    return await dupeBusinessClient.post("/api/v1/users/access_token", req).catch(error => {
        console.log(error);
    });
}

export async function getProfile() {
    return await dupeBusinessClient.get('/api/v1/profile').catch(error => {
        console.log(error);
    });
}